// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2932L","content":"LayoutSettings_content__1z58y"};